import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import Cookies from 'universal-cookie'
import styled from 'styled-components'
import SingleLeadMaturityStages from '../../2-leads/SingleLeadMaturityStages'
import { getLoansByUser } from '../../../../services/loanService'

import { getClusterByProject } from '../reduxLogic/reducers/clusters/getClusterByProjectSlice'
import { getAllProjects } from '../reduxLogic/reducers/projects/getAllProjectSlice'
import { useDispatch, useSelector } from 'react-redux'

import { Tabs, ConfigProvider } from 'antd'
import { HarvestLogs } from '../Users/Apiary/HarvestLogs'
import { ApiaryActivity } from '../Users/Apiary/ApiaryActivity'
import { Profitexpense } from '../Users/Apiary/ProfitLoss'
import { InspectHiveLog } from '../Users/Apiary/InspectHiveLog'
import { ApiaryInformation } from '../Users/Apiary/ApiaryInformation'

const cookies = new Cookies()
const token = cookies.get('access_token') // Get token from storage
const project_id = cookies.get('project_id')

const Container = styled.div`
  margin-left: 20%;
  margin-top: 4%;
`

const TopTabs = styled.div`
  display: flex;
  margin-bottom: 10px;
`

const TopTab = styled.button`
  padding: 10px 20px;
  background-color: lightgray;
  border: none;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &.active {
    background-color: #ff8701;
    color: white;
  }
`

const TabButton = styled.button`
  padding: 10px 15px;
  margin-right: 5px;
  margin-left: 2%;
  margin-bottom: 2%;
  background-color: lightgray;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &.active {
    background-color: #ff8701;
    color: white;
  }
`

const TabContent = styled.div`
  margin-left: 2%;
`

const SurveyTabs = () => {
  const [surveyData, setSurveyData] = useState([])
  const [userData, setUserData] = useState({})
  const [basicProfileData, setBasicProfileData] = useState(null)
  const [traineeData, setTraineeData] = useState({})
  const [selectedProjectId, setSelectedProjectId] = useState('')

  const [apiaryData, setApiaryData] = useState([])
  const [hideApiaryTab, setHideApiaryTab] = useState(false)
  const [leAppUserId, setLeAppUserId] = useState('')

  const dispatch = useDispatch()
  const { _id } = useParams()
  const urlParams = new URLSearchParams(window.location.search) // Get the query parameters
  const clusterName = urlParams.get('clusterName') // Get the clusterName from the query string
  const fieldViewId = urlParams.get('fieldViewId') // Get the fieldViewId from the query string
  useEffect(() => {
    dispatch(getAllProjects())
    getUserSurvey(_id)
    getUser(_id)
    getLoanDetails(_id)
  }, [dispatch, _id])

  useEffect(() => {
    if (traineeData?.project_id) {
      setSelectedProjectId(traineeData.project_id)
    } else if (project_id) {
      setSelectedProjectId(project_id)
    }
  }, [traineeData?.project_id, project_id])

  useEffect(() => {
    if (selectedProjectId) {
      dispatch(getClusterByProject(selectedProjectId))
    }
  }, [dispatch, selectedProjectId])

  const { clusterViaProjectData } = useSelector(
    state => state.clusterViaProjectData
  )

  const { projectData } = useSelector(
    state => state.allProjects
  )

  const getLoanDetails = async (id) => {
    try {
      const loans = await getLoansByUser(id);
      console.log('Fetched User Loans in Surveys:', loans);
      // Map to the structure expected by SingleLeadMaturityStages
      const mappedLoans = loans.map(loan => ({
        ...loan,
        recordType: 'loan',
        status: loan.loanStatus || loan.status,
      }));
      setTraineeData(prev => ({ ...prev, capital_info: mappedLoans }));
    } catch (error) {
      console.log('Error in getting loan details:', error)
    }
  }

  const getUserSurvey = async id => {
    try {
      const config = {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
      const res = await axios.get(
        `${process.env.REACT_APP_API_APP_FIELD_URL}/surveys/user/${id}`,
        config
      )
      const stages = res.data?.survey?.stages || []
      const sortedStages = reorderStages(stages);

      console.log(res.data.apiary, 'asc');
      const apiary = res.data.apiary ? res.data.apiary.sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at)) : [];
      if (apiary.length > 0) {
        setApiaryData([apiary[0]])
      }

      if (!res.data.apiary || res.data.apiary.length === 0) {
        setHideApiaryTab(true)
      }
      console.log('apiaryData', res.data.apiary)
      setSurveyData(sortedStages)
      console.log('surveyData', sortedStages)
      setLeAppUserId(res.data?.survey?.le_app_user || '')
      console.log('leAppUserId', res.data)

      if (sortedStages.length > 0) {
        setSurveyActiveTab(sortedStages[0].stage_name)
      }
    } catch (error) {
      console.log('Error in getting survey data:', error)
    }
  }

  const getBasicUser = async (id) => {
    try {
      const config = {
        headers: {
          Authorization: 'Bearer ' + token,
          source: 'humblebee_admin',
        },
      }
      const res = await axios.get(
        `${process.env.REACT_APP_API_APP_FIELD_URL}/surveys/bp/admin-base-profile`,
        config
      )

      const basicProfiles = res.data.data || [];
      const user = basicProfiles.find(profile => profile._id === id || profile.id === id);

      if (user) {
        // Map basic profile fields to userData structure
        const mappedUser = {
          _id: user._id,
          name: user.full_name,
          mobileNumber: user.mobile_number,
          gender: user.gender,
          fulladdress: `${user.village_name || ''}, ${user.block || ''}, ${user.district || ''}, ${user.state || ''}`,
          address: {
            state: user.state,
            district: user.district,
            block: user.block,
            village: user.village_name,
            location: null // Basic profiles might not have lat/long
          },
          userRoles: ['Basic Profile'], // Placeholder role
          cluster: user.cluster_id || '',
          profilePictureUrl: null // Basic profiles might not have picture
        };
        setUserData(mappedUser);

        // Map basic profile fields for renderTableData
        const formattedData = {
          candidateName: user.full_name,
          gender: user.gender,
          dob: user.dob,
          fatherName: user.father_name,
          education: user.education,
          category: user.category,
          village: user.village_name,
          block: user.block,
          district: user.district,
          state: user.state,
          mobileNumber: user.mobile_number,
          mobileNumberType: user.mobileNumberType,
          aadharNumber: user.aadhar_number,
          srlmAssociated: user.srlm_associated ? "Yes" : "No",
          disability: user.disability ? "Yes" : "No",
        };
        setBasicProfileData(formattedData);

        console.log('Mapped basic user data:', mappedUser);
      } else {
        console.log('User not found in basic profiles');
      }

    } catch (error) {
      console.log('Error in getting basic user data:', error);
    }
  }

  const getUser = async id => {
    try {
      const config = {
        headers: {
          Authorization: 'Bearer ' + token,
          source: 'humblebee_admin',
        },
      }
      const res = await axios.get(
        `${process.env.REACT_APP_API_APP_USER_URL}/user/user-id-details/${id}`,
        config
      )

      if (res.data && res.data.user) {
        setTraineeData(res.data.trainee)
        setUserData(res.data.user)
        console.log('user data see......', userData)
      } else {
        // Fallback to basic profile fetch if user not found in main user service
        console.log('User not found in main service, checking basic profiles...');
        getBasicUser(id);
      }
    } catch (error) {
      console.log('Error in getting user data:', error);
      // Fallback on error as well
      getBasicUser(id);
    }
  }

  const formatLabel = label =>
    label.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())

  const renderTableData = data => (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th
            style={{
              padding: '10px',
              borderBottom: '1px solid #ddd',
              color: 'orange',
              fontWeight: 'bold',
            }}
          >
            Field
          </th>
          <th
            style={{
              padding: '10px',
              borderBottom: '1px solid #ddd',
              color: 'orange',
              fontWeight: 'bold',
            }}
          >
            Value
          </th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(data).map(([key, value]) => (
          <tr key={key}>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>{formatLabel(key)}</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {key === 'lastRecordedYieldValue' ? (
                value ? value + " Metric Tone" : <span style={{ color: 'red' }}>NA</span>
              ) : key.includes('Cultivation') && !key.includes('Acre') ? (
                value ? value + ' ' + (data.unitForRecordingAreas || '') : <span style={{ color: 'red' }}>NA</span>
              ) : key === 'photos' || key === 'otherphotos' ? (
                Array.isArray(value) ? (
                  value.map((photoUrl, index) => (
                    <img
                      key={index}
                      src={photoUrl}
                      alt={`photo-${index}`}
                      style={{
                        width: '100px',
                        height: 'auto',
                        margin: '5px',
                        objectFit: 'fill',
                      }}
                    />
                  ))
                ) : (
                  <img
                    src={value}
                    alt="photo"
                    style={{ width: '100px', height: 'auto', margin: '5px' }}
                  />
                )
              ) : Array.isArray(value) ? (
                value.length > 0 ? (
                  typeof value[0] === 'object' ? (
                    // ✅ Show only plant, localName, and image
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                      {value.map((item, idx) => (
                        <div
                          key={idx}
                          style={{
                            border: '1px solid #ddd',
                            borderRadius: '10px',
                            padding: '10px',
                            width: '150px',
                            textAlign: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                          }}
                        >
                          <img
                            src={item.image}
                            alt={item.plant}
                            style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '8px' }}
                          />
                          <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{item.plant}</div>
                          <div style={{ color: '#666', fontSize: '13px' }}>{item.localName}</div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    value.join(', ')
                  )
                ) : (
                  <span style={{ color: 'red' }}>NA</span>
                )
              ) : typeof value === 'object' && value !== null ? (
                renderTableData(value)
              ) : (
                value ? value.toString() : <span style={{ color: 'red' }}>NA</span>
              )}
            </td>
          </tr>
        ))}

      </tbody>
    </table>
  )

  const renderStages = () => (
    <div>
      <SingleLeadMaturityStages
        capitalInfo={traineeData?.capital_info}
        leadId={_id}
        // projectId={project.projectId._id}
        selfInvestment={0}
        isEditable={true}
        loanAmountRequired={true}
        totalInvestment={0}
        // businessIdea={this.state.businessIdea}
        businessIdea={''}
        leadData={userData}
        leAppUserId={leAppUserId}
        fieldViewId={fieldViewId}
        refreshLeadData={false}
        changeOnHoldStatus={true}
      // changeDisqualificationStatus={
      //   this.changeDisqualificationStatus
      // }
      />
    </div>
  )


  const renderHarvestData = () => (

    <HarvestLogs apiaryData={apiaryData} />
  )

  const renderInspectData = () => {


    return (
      <InspectHiveLog apiaryData={apiaryData} userData={userData} />

    )
  }
  const renderProfitLossData = () => {
    return (
      <Profitexpense apiaryData={apiaryData} />
    )
  }
  const renderApiaryInformation = () => {
    return (
      <ApiaryInformation apiary={apiaryData[0]} index={0} />
    )
  }
  const renderApiaryActivityData = () => {
    return (
      <ApiaryActivity apiaryData={apiaryData} userData={userData} />
    )
  }

  const reorderStages = (stages) => {
    const order = [
      "candidateProfile",
      "cultivationDetails",
      "financialOverview",
      "beekeepingScope"    // <- put this last
    ];

    return stages.sort(
      (a, b) => order.indexOf(a.stage_name) - order.indexOf(b.stage_name)
    );
  };

  const renderApiaryData = () => (
    <div>
      {!apiaryData || apiaryData.length === 0 ? (
        <h2>No apiary data available</h2>
      ) : (
        <div>
          <Tabs
            tabBarStyle={{ color: "#ff8701" }}
            defaultActiveKey="6"
            type="card"
          >
            <Tabs.TabPane tab="Apiary Information" key="6">
              {renderApiaryInformation()}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Activities" key="3">
              {renderApiaryActivityData()}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Inspections" key="2">
              {renderInspectData()}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Profit & Loss" key="4">
              {renderProfitLossData()}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Harvest" key="5">
              {renderHarvestData()}
            </Tabs.TabPane>
          </Tabs>
        </div>
      )}
    </div>
  );

  const renderUserProfile = () => (
    <div>
      <h2>Profile</h2>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Profile Picture</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <img
                style={{
                  width: '150px',
                  height: '150px',
                  objectFit: 'fill',
                  border: '1px solid orange',
                  borderRadius: '50%',
                  backgroundColor: 'lightgray',
                }}
                src={
                  userData?.profilePictureUrl ||
                  'https://www.w3schools.com/howto/img_avatar.png'
                }
                alt="Profile Pic"
              />
            </td>
          </tr>
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Name</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {userData?.name}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Mobile Number</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {userData?.mobileNumber}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Gender</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {userData?.gender}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Address</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {userData?.fulladdress}
            </td>
          </tr>
          {userData?.address?.location?.latitude ? (
            <tr>
              <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                <strong>Location</strong>
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${userData?.address?.location?.latitude},${userData?.address?.location?.longitude}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  View on Map
                </a>
              </td>
            </tr>
          ) : null}
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Roles</strong>
            </td>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              {userData?.userRoles?.map(role => (
                <span
                  key={role}
                  style={{
                    border: '1px solid gray',
                    padding: '4px',
                    borderRadius: '8px',
                    backgroundColor: 'orange',
                    margin: '2px',
                  }}
                >
                  {role}
                </span>
              ))}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
              <strong>Existing Cluster</strong>
            </td>
            <td
              style={{
                padding: '10px',
                borderBottom: '1px solid #ddd',
                color: 'green',
              }}
            >
              {(() => {
                const assignedCluster = Array.isArray(clusterViaProjectData)
                  ? clusterViaProjectData.find(c => c._id === userData?.cluster)
                  : null;
                if (assignedCluster) {
                  return assignedCluster.clusterName;
                } else if (clusterName) {
                  return clusterName;
                } else {
                  return <span style={{ color: 'red' }}>No cluster assigned</span>;
                }
              })()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )

  const [surveyActiveTab, setSurveyActiveTab] = useState(
    surveyData[0]?.stage_name
  )

  const handleTabChange = key => {
    setSurveyActiveTab(key)
  }



  const renderSurveySection = () => (
    <div style={{ marginTop: "10px" }}>
      {/* <h2 style={{ color: "#000000ff", marginBottom: "20px" }}>Profile</h2> */}

      <Tabs
        tabBarStyle={{ color: '#ff8701' }}
        activeKey={surveyActiveTab}
        onChange={handleTabChange}
        type="line"
      >
        {surveyData.map(stage => (
          <Tabs.TabPane tab={formatLabel(stage.stage_name)}
            key={stage.stage_name}></Tabs.TabPane>
        ))}
      </Tabs>

      <div>
        <TabContent>
          {!surveyData.length && (
            <div>
              {basicProfileData ? (
                <div>
                  <div style={{ marginBottom: "25px" }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                            <img
                              style={{
                                width: '150px',
                                height: '150px',
                                objectFit: 'fill',
                                border: '1px solid orange',
                                borderRadius: '50%',
                                backgroundColor: 'lightgray',
                              }}
                              src={
                                userData?.profilePictureUrl ||
                                'https://www.w3schools.com/howto/img_avatar.png'
                              }
                              alt="Profile Pic"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {renderTableData(basicProfileData)}
                </div>
              ) : userData && userData.name ? (
                renderUserProfile()
              ) : (
                <h2>No survey data available</h2>
              )}
            </div>
          )}
          { /* surveyData.map(stage =>
          stage.stage_name === surveyActiveTab ? (

            
            <div key={stage._id}>{renderTableData(stage.form_data)}</div>
          ) : null
        ) */}
          {surveyData.map(stage =>
            stage.stage_name === surveyActiveTab ? (
              <div key={stage._id}>

                {/* 1️⃣ — SHOW PROFILE PICTURE ONLY IN CANDIDATE PROFILE TAB */}
                {stage.stage_name === "candidateProfile" && (
                  <div style={{ marginBottom: "25px" }}>


                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                            <img
                              style={{
                                width: '150px',
                                height: '150px',
                                objectFit: 'fill',
                                border: '1px solid orange',
                                borderRadius: '50%',
                                backgroundColor: 'lightgray',
                              }}
                              src={
                                userData?.profilePictureUrl ||
                                'https://www.w3schools.com/howto/img_avatar.png'
                              }
                              alt="Profile Pic"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                {/* 2️⃣ — NORMAL RENDERING OF FORM DATA */}
                {renderTableData(stage.form_data)}
              </div>
            ) : null
          )}

        </TabContent>
      </div>
    </div>
  )


  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            cardBg: 'light',
            itemColor: 'orange',
            itemActiveColor: '#ff8701',
          },
        },
      }}
    >
      <Container>
        <div style={{ display: 'flex', justifyContent: 'left' }}>
          <label style={{ fontSize: '20px', color: '#ff8701' }}>
            {userData?.name}
          </label>
          <span style={{ fontSize: '20px', marginLeft: '1%' }}>
            {' '}
            - {userData?.mobileNumber}
          </span>
          <a
            href={`https://api.whatsapp.com/send?phone=91${userData?.mobileNumber}`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '1%' }}
          >
            <img
              src="https://img.icons8.com/color/48/000000/whatsapp.png"
              alt="whatsapp"
              style={{ width: '30px', height: '30px' }}
            />
          </a>
        </div>

        {/* Cluster Assignment Section */}
        <div style={{
          border: '1px solid #ddd',
          borderRadius: '8px',
          padding: '15px',
          marginTop: '15px',
          marginBottom: '15px',
          backgroundColor: '#f9f9f9',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '15px'
        }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center' }}>
            <div>
              <strong>Existing Cluster: </strong>
              <span style={{
                color: (traineeData?.cluster_id || userData?.cluster) ? 'green' : 'red',
                fontWeight: 'bold',
                marginLeft: '5px'
              }}>
                {(() => {
                  const activeClusterId = traineeData?.cluster_id || userData?.cluster || '';
                  const assignedCluster = Array.isArray(clusterViaProjectData)
                    ? clusterViaProjectData.find(c => c._id === activeClusterId)
                    : null;
                  if (assignedCluster) {
                    return assignedCluster.clusterName;
                  } else if (clusterName) {
                    return clusterName;
                  } else {
                    return 'No cluster assigned';
                  }
                })()}
              </span>
            </div>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{ margin: 0 }}><strong>Project:</strong></label>
              <select
                style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none' }}
                value={selectedProjectId || ''}
                onChange={e => {
                  const val = e.target.value;
                  setSelectedProjectId(val);
                  // Clear cluster when project changes
                  if (traineeData && Object.keys(traineeData).length > 0) {
                    setTraineeData({ ...traineeData, cluster_id: '' });
                  }
                  setUserData({ ...userData, cluster: '' });
                }}
              >
                <option value="">Select Project</option>
                {Array.isArray(projectData) && projectData.map(p => (
                  <option key={p._id} value={p._id}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <label style={{ margin: 0 }}><strong>Cluster:</strong></label>
              <select
                style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none' }}
                name="cluster"
                value={traineeData?.cluster_id || userData?.cluster || ''}
                onChange={e => {
                  const val = e.target.value;
                  if (traineeData && Object.keys(traineeData).length > 0) {
                    setTraineeData({ ...traineeData, cluster_id: val });
                  }
                  setUserData({ ...userData, cluster: val });
                }}
              >
                <option value="">No Cluster (Unassigned)</option>
                {Array.isArray(clusterViaProjectData) && clusterViaProjectData.map(cluster => (
                  <option key={cluster._id} value={cluster._id}>
                    {(cluster.projectId?.name || 'No Project') + ' - ' + cluster.clusterName}
                  </option>
                ))}
              </select>
            </div>

            <button
              style={{
                backgroundColor: '#ff8701',
                color: 'white',
                padding: '6px 15px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
              onClick={() => {
                const config = {
                  headers: {
                    Authorization: 'Bearer ' + token,
                    source: 'humblebee_admin',
                  },
                }
                const activeClusterId = traineeData?.cluster_id || userData?.cluster || '';
                axios
                  .post(
                    `${process.env.REACT_APP_API_APP_FIELD_URL}/clusters/clusters/add-lead`,
                    {
                      user_id: _id,
                      cluster_id: activeClusterId,
                      project_id: selectedProjectId,
                    },
                    config
                  )
                  .then(res => {
                    alert('User updated successfully')
                    getUser(_id)
                  })
                  .catch(err => {
                    console.log(err)
                    alert('Error updating user')
                  })
              }}
            >
              Update Cluster
            </button>
          </div>
        </div>

        <Tabs
          tabBarStyle={{ color: '#ff8701' }}
          defaultActiveKey="1"
          type="card"
        >
          <Tabs.TabPane tab="Profile" key="1">
            {/* {renderUserProfile()} */}
            {renderSurveySection()}

          </Tabs.TabPane>

          <Tabs.TabPane tab="Investment" key="3">
            {renderStages()}
          </Tabs.TabPane>
          {!hideApiaryTab && (
            <Tabs.TabPane tab="Apiary" key="4">
              {renderApiaryData()}
            </Tabs.TabPane>
          )}
        </Tabs>
      </Container>
    </ConfigProvider>
  )
}

export default SurveyTabs
